import React from 'react'
import { graphql } from 'gatsby'
import { format } from 'date-fns'

// Components
import Layout from '../components/layout'
import ProductCard from '../components/productCard'
import Seo from '../components/seo'

export const query = graphql`
  query PastAuction($id: String) {
    pastAuctionsJson(id: { eq: $id }) {
      ...PastAuctionsJsonFragment
    }
  }
`

const PastAuctionTemplate = ({ data }) => {
  const information = data.pastAuctionsJson.information
  const auction = information.auction
  let items = information.listings.sort((a, b) => {
    // Convert lotNumber to numbers and compare
    return parseInt(a.lotNumber) - parseInt(b.lotNumber)
  })

  return (
    <Layout>
      <section className='component-text mx-auto max-w-screen-xl lg:p-10 p-6'>
        <div className='prose max-w-none mb-10'>
          <h1 className='text-2xl'>{auction.title}</h1>
          <p className='text-base'>{auction.description}</p>
          <div>Ended: {format(new Date(auction.endsAt), 'do MMMM yyyy H:mm')}</div>
        </div>
        <ul className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          {items.map((item) => {
            return (
              <li key={item.uuid} className={item.countryCode}>
                <ProductCard hit={item} type='pastAuction' auctionUuid={auction.uuid} />
              </li>
            )
          })}
        </ul>
      </section>
    </Layout>
  )
}

export default PastAuctionTemplate

export const Head = ({ data, location }) => {
  const pageData = data.pastAuctionsJson.information.auction
  const { pathname } = location
  return (
    <>
      <Seo pathname={pathname} title={pageData.title} description={pageData.description} />
    </>
  )
}
